import React from 'react'
import FontAwesomeIcon from 'core/components/FontAwesomeIcon'
import Text from 'core/elements/Text'

const LoadingTextWithSpinner = () => {
  return (
    <Text variant="body2">
      <FontAwesomeIcon solid spin size="md">
        refresh
      </FontAwesomeIcon>{' '}
      Loading
    </Text>
  )
}

export default LoadingTextWithSpinner
